module.exports = __webpack_public_path__ + "static/media/checkmark.920499ce.svg";